import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField/TextField';
import Loading from '../../../../components/Loading/Loading';
import CustomizedMap from '../../../../components/CustomizedMap/CustomizedMap';

//Api
import cep_api from '../../../../api/cep_api';

//Helpers
import { validarCampos } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';
import { showMessage } from '../../../../helpers/message';
export default function EnderecoDestino({ destino, setDestino, errors, setErrors, campos }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Change para o campo de cep onde carrega os outros campos ao ser totalmente preenchido
    const onChangeCep = (e) => {
        const { name, value } = e.target;
        const _destino = {
            ...destino,
            [name]: value
        }

        if (_destino.cep.length == 8) {
            setLoading(true);
            cep_api.get(_destino.cep).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _destino.bairro = response.data.bairro;
                _destino.uf = response.data.uf;
                _destino.logradouro = response.data.logradouro;
                _destino.cidade = response.data.localidade;
                const erros = validarCampos(_destino, campos);
                setErrors(erros[0]);
                const endereco = {
                    NumeroCep: _destino.cep,
                    Bairro: _destino.bairro,
                    Logradouro: _destino.logradouro,
                    Cidade: _destino.cidade,
                    Estado: _destino.estado,
                    Numero: _destino.numero,
                    Latitude: "",
                    Longitude: "",
                    EnderecoFormatado: "",
                }
                setLoading(true);
                cep_api.GeoCode(endereco).then(response => {
                    if (response.data.latitude && response.data.longitude) {
                        _destino.latitude = parseFloat(response.data.latitude.replace(",", "."));
                        _destino.longitude = parseFloat(response.data.longitude.replace(",", "."));
                    }
                    setDestino(_destino);
                }).catch(e => {
                    showMessage("Aviso", e.message, "error");
                }).finally(f => setLoading(false));
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base", "error", null);
            }).finally(f => setLoading(false));
        } else {
            setDestino(_destino);
        }
    }

    //Change para os outros campos do endereço
    const onChangeEndereco = (e) => {
        const { name, value } = e.target;
        const _destino = {
            ...destino,
            [name]: value
        }

        const erros = validarCampos(_destino, campos.filter(c => c.name == name));
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            const _errors = { ...errors, ...erros[0] };
            setErrors(_errors);
        }

        setDestino(_destino)

    }
    //Change para o mapa pegando a longitude e latitude
    const onChangeLocation = (location) => {
        setDestino({ ...destino, latitude: location.lat, longitude: location.lng })
    }
    return (
        <div>
            {loading && <Loading />}
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"9"} label={"* CEP"} invalid={errors.cep ? true : false} value={destino.cep} mask={mascaras.cepMask} onChange={onChangeCep} name="cep" />
                    {errors.cep && <span className={"form-control-label text-danger"}>{errors.cep.message}</span>}
                </Col>
                <Col md="12" lg="6">
                    <TextField maxLength="150" label={"* Cidade"} invalid={errors.cidade ? true : false} value={destino.cidade} onChange={onChangeEndereco} name="cidade" />
                    {errors.cidade && <span className={"form-control-label text-danger"}>{errors.cidade.message}</span>}
                </Col>
                <Col md="12" lg="2">
                    <TextField pattern="([aA-zZ]+)" maxLength="2" label={"* UF"} invalid={errors.uf ? true : false} value={destino.uf} onChange={onChangeEndereco} name="uf" />
                    {errors.uf && <span className={"form-control-label text-danger"}>{errors.uf.message}</span>}
                </Col>

            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength="150" label={"* Bairro"} invalid={errors.bairro ? true : false} value={destino.bairro} onChange={onChangeEndereco} name="bairro" />
                    {errors.bairro && <span className={"form-control-label text-danger"}>{errors.bairro.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength="150" label={"* Logradouro"} invalid={errors.logradouro ? true : false} value={destino.logradouro} onChange={onChangeEndereco} name="logradouro" />
                    {errors.logradouro && <span className={"form-control-label text-danger"}>{errors.logradouro.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength="10" label={"* Número"} invalid={errors.numero ? true : false} value={destino.numero} onChange={onChangeEndereco} name="numero" />
                    {errors.numero && <span className={"form-control-label text-danger"}>{errors.numero.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength="20" label={"Complemento"} invalid={errors.complemento ? true : false} value={destino.complemento} onChange={onChangeEndereco} name="complemento" />
                    {errors.complemento && <span className={"form-control-label text-danger"}>{errors.complemento.message}</span>}
                </Col>
            </Row>
            <Row className='d-flex align-items-center justify-content-center'>
                <Col md="12" lg="12" className=' shadow rounded-3 overflow-hidden m-0 p-0 mb-4' style={{ width: "80%", height: "250px" }}>
                    {!loading &&
                        <CustomizedMap positionCenter addNewMarker position={{ lat: destino.latitude ? destino.latitude : "", lng: destino.longitude ? destino.longitude : "" }} setPosition={onChangeLocation} />
                    }
                </Col>
            </Row>
        </div>
    )
}